module.exports = __webpack_public_path__ + "static/img/bingqiu_logo1.60132e6.png";